import fetch from "auth/FetchInterceptor"
import { AUTH_TOKEN } from "constants/AuthConstant"

const ChatService = {}

ChatService.getChats = function ({ page = 1, limit = 20, search }) {
  let url = `chat?page=${page}&limit=${limit}`
  if (search) {
    url = url + `&search=${search}`
  }
  return fetch({
    method: "get",
    url: url,
    headers: {
      Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
    },
  })
}

ChatService.getChatById = function (chatId) {
  return fetch({
    method: "get",
    url: `chat/${chatId}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
    },
  })
}

ChatService.getMessages = function (chatId, page = 1, limit = 50) {
  return fetch({
    method: "get",
    url: `chat/${chatId}/messages?page=${page}&limit=${limit}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
    },
  })
}

ChatService.sendMessage = function (data) {
  return fetch({
    method: "post",
    url: `chat/send-message`,
    data,
    headers: {
      Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
    },
  })
}

ChatService.createChat = function (clientId) {
  return fetch({
    method: "post",
    url: `chat/create`,
    data: { clientId },
    headers: {
      Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
    },
  })
}

ChatService.countUnread = function () {
  return fetch({
    method: "get",
    url: `chat/unRead/count`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
    },
  })
}

ChatService.exportChatPdf = function (chatId) {
  return fetch({
    method: "get",
    url: `chat/${chatId}/export-pdf`,
    responseType: "blob",
    headers: {
      Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
    },
  })
}

export default ChatService
